import React, { useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MediaBtnContainer } from '../../../pre-meeting/components/Buttons'
import { SidebarModeType } from '../../types/types'
import { Tip } from '../../../../components/Tip'
import { useZoomContext } from '../../../../context/ZoomContext'
import { useTranslation } from 'react-i18next'

export const ChatIcon = () => {
    const { t } = useTranslation('meeting')
    const { sidebarMode, unReadMessages, setSidebarMode, zoomClient, setUnReadMessages } = useZoomContext()

    const onToggleSidebar = useCallback(
        (toggle: SidebarModeType) => {
            setSidebarMode(oldSidebarMode => {
                return oldSidebarMode === toggle ? null : toggle
            })
        },
        [setSidebarMode]
    )

    const onChatMessage = useCallback(
        () => {
            if (sidebarMode !== 'messages') {
                setUnReadMessages(prev => {
                    // If false, create a new object with chat set to true
                    if (!prev) return { chat: true };
                    // Otherwise update the existing object
                    return { ...prev, chat: true };
                });
            }
        },
        [setUnReadMessages, sidebarMode]
    )

    useEffect(() => {
        zoomClient.on('chat-on-message', onChatMessage)
        return () => {
            zoomClient.off('chat-on-message', onChatMessage)
        }
    }, [onChatMessage, zoomClient])

    return (
        <div>
            <MediaBtnContainer
                active={sidebarMode === 'messages'}
                square
                data-tooltip-id="chat-action"
                onClick={e => {
                    e.stopPropagation()
                    // Clear the unread chat status when opening chat
                    if (sidebarMode !== 'messages') {
                        setUnReadMessages(prev => {
                            if (!prev) return false;
                            const newState = { ...prev };
                            delete newState.chat;
                            // If no unread messages left, set to false
                            return Object.keys(newState).length > 0 ? newState : false;
                        });
                    }
                    onToggleSidebar('messages')
                }}
                style={{ position: 'relative' }}
            >
                <div style={{ position: 'relative' }}>
                    <FontAwesomeIcon icon={['far', 'message-dots']} />
                    {unReadMessages && unReadMessages.chat && (
                        <FontAwesomeIcon
                            icon={['fas', 'circle']}
                            style={{
                                color: '#FF647C',
                                position: 'absolute',
                                top: -3,
                                right: -7,
                                fontSize: '12px',
                            }}
                        />
                    )}
                </div>
            </MediaBtnContainer>
            <Tip
                id="chat-action"
                content={sidebarMode === 'messages' ? t('chat.hideMessages') : t('chat.showMessages')}
            />
        </div>
    )
}
